<template>
  <div class="layout-container cursor-pointer">
    <button class="btn btn-sm btn-info p-50 btn-index" v-if="showMoveControls">
      <i class="">{{ view.position }}</i>
    </button>
    <button
      class="btn btn-sm btn-danger rounded-circle p-50 btn-remove"
      v-if="showMoveControls"
      @click="removeView">
      <i class="feather icon-x"></i>
    </button>
    <button
      class="btn btn-sm btn-success rounded-circle p-50 btn-remove"
      v-if="showAddControl"
      @click="addView">
      <i class="feather icon-plus"></i>
    </button>
    <button
      @click="moveView('up')"
      class="btn btn-sm btn-danger rounded-circle p-50 btn-remove videoTour-move-up-item"
      v-if="showMoveControls">
      <i class="feather icon-arrow-up"></i>
    </button>
    <button
      @click="moveView('down')"
      class="btn btn-sm btn-danger rounded-circle p-50 btn-remove videoTour-move-down-item"
      v-if="showMoveControls">
      <i class="feather icon-arrow-down"></i>
    </button>
    <div class="grid-layout__container">
      <p class="text-center text-name">{{ view.name }}</p>
      <Widget
        v-for="widget in items"
        :widget="widget"
        :key="widget.local_id"
        :style="{ ...gridItemStyles(widget) }"
        :tab-data="tabData"
        origin="VideoTourLayout"
      />
    </div>
  </div>
</template>

<script>
import Widget from "../LayoutViews/LayoutViewsSlot.vue";
import useLayout from "@/composables/layouts";
import { onMounted, reactive, toRefs, computed } from "@vue/composition-api";
import defaultLayout from "@/config/defaultLayout";
import store from "@/store";

export default {
  components: {
    Widget,
  },
  props: {
    view: Object,
    showMoveControls: {
      type: Boolean,
      default: false,
    },
    showAddControl: {
      type: Boolean,
      default: true,
    },
    slotHeight: {
      type: Number,
      default: 25
    }
  },
  setup(props, { emit }) {
    const userLayouts = computed(() => {
      return store.state.layouts.userLayouts.map((l) => ({
        id: l.id,
        name: l.name,
        grid: l.data,
      }));
    });
    let layout = null;

    if (props.view.layout_id === "default") {
      layout = defaultLayout;
    } else {
      layout = userLayouts.value.find((layout) => layout.id === props.view.layout_id);
      if (layout) {
        layout = Object.assign({}, { ...layout });
      } else {
        layout = defaultLayout;
      }
    }

    const tabData = props.view.data;
    const { gridItemStyles } = useLayout(layout, props.slotHeight);
    const state = reactive({
      items: [],
    });

    const removeView = (event) => {
      event.stopPropagation();
      emit("removeView", props.view.id);
    };

    const addView = (event) => {
      event.stopPropagation();
      emit("addView", props.view);
    };

    const moveView = (direction) => {
      emit("moveView", props.view.id, direction);
    };

    onMounted(() => {
      if (props.view && props.view.data.gridItems) {
        state.items = props.view.data.gridItems;
      } else if (layout && layout.grid) {
        state.items = [...layout.grid];
      } else {
        state.items = [];
      }
    });

    return {
      ...toRefs(state),
      gridItemStyles,
      tabData,
      addView,
      removeView,
      moveView
    };
  },
};
</script>

<style lang="scss" scoped>
.layout-container {
  position: relative;
  min-height: 120px;
  .btn-remove {
    position: absolute;
    top: 0;
    right: 0;
    z-index: 3;
    display: none;
  }
  .btn-index {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 3;
  }
  &.selected,
  &:hover {
    .btn-remove {
      display: block;
    }
    .app-grid {
      .slot-item {
        border: 1px solid #fff;
      }
    }
  }
}

.text-name {
  top: 0;
  left: 0;
  right: 0;
  z-index: 2;
  position: absolute;
  background: rgba(0, 0, 0, 0.2);
}
</style>
